import React, { useState } from 'react';
import { useHeaderContext } from '@context';
import Grid from '@components/Grid';
import { useSticky } from '@hooks';

import HeaderNav from './HeaderNav';
import HeaderNavContainer from './HeaderNavContainer';
import HeaderWrapper from '../HeaderWrapper';
import { Logo, Reinsurance, B2BConnect } from './components';

const Header = () => {
  const { platform, isAuthenticated, isB2B } = useHeaderContext();
  const [isSticky] = useSticky();
  const [isMenuItemsOpened, setMenuItemsOpened] = useState(false);

  return (
    <HeaderNavContainer
      isSticky={isSticky}
      isMenuItemsOpened={isMenuItemsOpened}
    >
      <HeaderNav>
        <Grid isHeaderSticky={isSticky} isMenuOpened={isMenuItemsOpened}>
          {gridStyles => (
            <>
              <HeaderWrapper
                classNames={{
                  product: gridStyles.product,
                  promo: gridStyles.promo,
                  search: gridStyles.search,
                  contact: gridStyles.contact,
                  account: gridStyles.account,
                  list: gridStyles.list,
                  basket: gridStyles.basket,
                  dropdown: gridStyles.menuDropdown,
                  mobileBasket: gridStyles.mobileBasket,
                  mobileAccount: gridStyles.mobileAccount,
                  mobileMenu: gridStyles.mobileMenu,
                  familiesContainer: gridStyles.familiesContainer,
                }}
                isSticky={isSticky}
                isMenuItemsOpened={isMenuItemsOpened}
                onMenuOpened={setMenuItemsOpened}
              >
                <Logo className={gridStyles.logo} />
                <Reinsurance className={gridStyles.reinsurance} />
                <B2BConnect
                  isAuthenticated={isAuthenticated}
                  isB2B={isB2B}
                  platform={platform}
                  className={gridStyles.B2BConnect}
                />
              </HeaderWrapper>
            </>
          )}
        </Grid>
      </HeaderNav>
    </HeaderNavContainer>
  );
};

Header.displayName = 'Header';

export default Header;
